import { Button } from '@mui/material';
import React from 'react';

const CustomButton = ({ variant = 'contained', color = 'secondary', startIcon, onClick = () => {}, title='', disabled = false, ...props }) => (
    <Button disabled={disabled} variant={variant} color={color} startIcon={startIcon} onClick={onClick} {...props}>
        {title}
    </Button>
);

export default CustomButton;
